export const ERROR_IDPAGO_INVALIDO = [
  {
    codigo: 'PAGOS-19',
    mensaje: 'No se encontro informaciòn de pago con el id de pago.',
  },
];
